import { createContext, Dispatch, SetStateAction, useState } from 'react';
import {
  ServiceSurveyCard,
  ServiceSurveyMobileCard
} from './ServiceSurveyCard';
import {
  ServiceSurveyCompleteDialog,
  ServiceSurveyDialog
} from './ServiceSurveyDialog';

interface SurveyState {
  progress: boolean;
  complete: boolean;
}

export const ServiceSurveyContext = createContext<{
  surveyOpen?: SurveyState;
  setSurveyOpen?: Dispatch<SetStateAction<SurveyState>>;
}>({});

interface ServiceSurveyProps {
  children: React.ReactNode;
}

const ServiceSurvey = ({ children }: ServiceSurveyProps) => {
  const [surveyOpen, setSurveyOpen] = useState({
    progress: false,
    complete: false
  });

  return (
    <ServiceSurveyContext.Provider value={{ surveyOpen, setSurveyOpen }}>
      <ServiceSurveyDialog
        open={surveyOpen.progress}
        onCompleteOpen={() =>
          setSurveyOpen({ complete: true, progress: false })
        }
        onClose={() => setSurveyOpen({ complete: false, progress: false })}
      />
      <ServiceSurveyCompleteDialog
        open={surveyOpen.complete}
        onClose={() => setSurveyOpen((prev) => ({ ...prev, complete: false }))}
      />
      {children}
    </ServiceSurveyContext.Provider>
  );
};

ServiceSurvey.Card = ServiceSurveyCard;
ServiceSurvey.MobileCard = ServiceSurveyMobileCard;
export default ServiceSurvey;
